export const BROWSER_BANNER_LOCAL_STORAGE_KEY = 'alva:incompatible-browser-prompt-seen';
